export default __webpack_public_path__ + "static/media/selectedroomicon0.5934c793.svg";